import { render } from "./MarginGlobal.vue?vue&type=template&id=5326c226"
import script from "./MarginGlobal.vue?vue&type=script&lang=js"
export * from "./MarginGlobal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dev.pbf.infonetglobal.tech/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__